module.exports = __webpack_public_path__ + "img/abraham-doras-shadd.366deadd.png";